import { get_axios_instance, api_variables,errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_ESS_LOGIN);
var axios_instance_bulk_download = get_axios_instance(api_variables.SERVICE_ESS_BULK_LOGIN_DOWNLOAD_TEMPLATE);
var axios_instance_bulk_upload = get_axios_instance(api_variables.SERVICE_ESS_BULK_LOGIN_UPLOAD_TEMPLATE);
var axios_instance_resetEssPassword = get_axios_instance(api_variables.SERVICE_ESS_PASSWORD_RESET);

const _pk_name = "id";

const state = {
  data:{},
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },
  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },
  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.data = payload;
    //console.log('exit data', state.exits);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/dashboard/oganisation/essManagement/fetchAll] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: payload
      });
      
      commit("setFetching", false);
      //console.log("[state/dashboard/payroll/itReports/fetchAll] res: ", res);
    //   if(res.status == 200) {
    //     commit("set", payload);
    //   }
     commit("set", res.data.rows);
      return res;
    }catch (error){
      //console.log('error', error.response);
      throw errorHandler(error.response);
    }
  },

  async create({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch (error){
      //console.log('error', error.response);
      throw errorHandler(error.response);
        
    }
  },

  async resetEssPassword({commit},payload){
      try{
         commit("setSaving",true);
        let res = await axios_instance_resetEssPassword.post('',{
          employeeCode:payload.employeeCode,
          le_id:payload.le_id,
          password:payload.password
        })
        commit("setSaving", false);
        return res
      }catch(error){
       throw errorHandler(error.response)
      }
  },

  async update({commit}, payload) {
      //console.log("[state/dashboard/oganisation/essManagement/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.emp_id}`, payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/update] res: ", res);
      if(res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    }catch (error){
      //console.log('error', error.response);
      throw errorHandler(error.response);
        
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/payroll/payGroup/delete] Payload:", payload);
    //console.log("[state/payroll/payGroup/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEmployeeById", payload.id);
      }
    }catch (error){
      //console.log('error', error.response);
      throw errorHandler(error.response);
        
    }
  },

  async downloadESSBulkTemplate({ commit }, payload) {
    try {
      let res = await axios_instance_bulk_download.post(`/`, );

      if (res.data.status) {
        const link = document.createElement("a");
        link.href = res.data.payload;
        link.setAttribute("download", payload + ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
        throw errorHandler(error.response);
    }
  },

  async uploadEssBulk({ commit }, payload) {
    try {
        let res = await axios_instance_bulk_upload.post('/', payload);

        //console.log("IT bulk", res)
        return res;
    } catch (err) {
        //console.log(err);
        return err;
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions
}